// extracted by mini-css-extract-plugin
export var buttons = "_bw-0";
export var buttonsActive = "_bw-h";
export var cancelConfirm = "_bw-1";
export var closeButton = "_bw-2";
export var column = "_bw-3";
export var container = "_bw-4";
export var detailHeader = "_bw-6";
export var detailTitle = "_bw-7";
export var detailsContent = "_bw-5";
export var header = "_bw-8";
export var headerWithClose = "_bw-9";
export var icon = "_bw-a";
export var infoIcon = "_bw-c";
export var informationContainer = "_bw-b";
export var sideDrawer = "_bw-d";
export var sideDrawerOpen = "_bw-e";
export var stickyFooter = "_bw-f";
export var typeOption = "_bw-g";